import React, { createContext, useEffect, useState, useCallback } from 'react'
import { useWallet } from 'use-wallet'

import {
  getPoolContract,
  getERC20Token,
  tokenAddress,
  poolsAddress,
} from 'lottery/constants'

export const AccountContext = createContext({
  poolsContract: null,
  ubetToken: null,
  connect: () => {},
})

const AccountProvider = ({ children }) => {
  const { ethereum, account } = useWallet()
  const [poolsContract, setPoolsContract] = useState(null)
  const [ubetToken, setubetToken] = useState(null)

  useEffect(() => {
    window.addEventListener('load', loadAccount)

    return () => {
      window.removeEventListener('load', loadAccount)
    }
  }, [])

  const loadAccount = async () => {
    if (ethereum) {
      const poolsContract = getPoolContract(ethereum)
      const ubetToken = getERC20Token(ethereum, tokenAddress)
      setPoolsContract(poolsContract)
      setubetToken(ubetToken)
    }
  }

  const getAllowance = async (ERC20TokenAddress) => {
    if (ethereum === 'undefined') return
    const ERC20Token = getERC20Token(ethereum, ERC20TokenAddress)
    if(!ERC20Token) {
      return undefined
    }
    const allowance = await ERC20Token.methods
      .allowance(account, poolsAddress)
      .call()
    return allowance
  }

  const getContractOwner = async () => {
    if (!poolsContract) return
    const contractOwner = await poolsContract.methods
      .owner()
      .call()
    return contractOwner
  }

  const getToken = useCallback(
    async (ERC20TokenAddress) =>
      ethereum ? getERC20Token(ethereum, ERC20TokenAddress) : undefined,
    [ethereum]
  )

  return (
    <AccountContext.Provider
      value={{ poolsContract, ubetToken, loadAccount, getAllowance, getToken, getContractOwner }}
    >
      {children}
    </AccountContext.Provider>
  )
}

export default AccountProvider
